import { render, staticRenderFns } from "./AuroraBoxAction.vue?vue&type=template&id=42dc695d&scoped=true"
import script from "./AuroraBoxAction.vue?vue&type=script&lang=js"
export * from "./AuroraBoxAction.vue?vue&type=script&lang=js"
import style0 from "./AuroraBoxAction.vue?vue&type=style&index=0&id=42dc695d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dc695d",
  null
  
)

export default component.exports